import React from 'react';

/**
 * Static ClinLexis logo with a gentle pulse for thinking/processing states.
 * Replaces the previous animated brain-network SVG.
 */
export const AnimatedLogo: React.FC<{ size?: number }> = ({ size = 20 }) => {
  return (
    <img
      src="/logo.png"
      alt="ClinLexis"
      width={size}
      height={size}
      className="flex-shrink-0 animate-pulse"
      style={{ objectFit: 'contain' }}
    />
  );
};
